import { tokenService } from '@/services/tokenService'

/**
 * Feature flags for the consultant app.
 *
 * Read from the dex-config `features` array, the same list pitstop-ui reads from
 * `state.auth.features`. submittals-service returns it on `POST /otp/verify` and
 * on every `POST /auth/refresh`, and tokenService keeps it with the tokens — so a
 * flag is switched by editing dex-config, not by rebuilding this app.
 *
 * Fails closed: before sign-in, or if the service sent no list, every flag reads
 * as off.
 */
export const featureConstant = {
  SUBMITTALS_PHASE_2: 'SUBMITTALS_PHASE_2',
}

export const isFeatureEnabled = featureName => tokenService.getFeatures().includes(featureName)
